import { PURCHASE_ORDERS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/purchase_orders_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['purchaseOrdersIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
